import { useState ,useEffect} from "react";
import { postAccionEmpleado, deleteAccionEmpleado,  getAccionesEmpleadosPanel } from "../../services/AccionesEmpleadosServices";
import { getAccionesLista } from "../../services/AccionesServices";
import { AccionesEmpleadosContext } from "./AccionesEmpleadosContext"

export const AccionesEmpleadosState = ({ children }) => {
    const getAccionesEmpleadosPanelData = async (searchSel) => {
        let res = await getAccionesEmpleadosPanel(searchSel)
        return res;
    }

    const postAccionEmpleadoData = async (body) => {
        const res = await postAccionEmpleado(body)
        if (res) getAccionesEmpleadosPanelData()
        return res
    }

    const deleteAccionEmpleadoData = async (body) => {
        const res = await deleteAccionEmpleado(body)
        if (res) getAccionesEmpleadosPanelData()
        return res
    }

    const getAccionesListaData = async () => {
        let res = await getAccionesLista()
        return res;
    }

    return <AccionesEmpleadosContext.Provider value={{
        getAccionesEmpleadosPanelData,
        postAccionEmpleadoData,
        deleteAccionEmpleadoData,
        getAccionesListaData
    }} >
        {children}
    </AccionesEmpleadosContext.Provider>
}